import React from 'react';
import { Neo, Views } from '@singularsystems/neo-react';
import InvestmentSetupVM from './InvestmentSetupVM';
import { observer } from 'mobx-react';
import { DateCycleListComponent } from './Components/DateCycleList';
import InterestRateCalculationTypeListComponent from './Components/InterestRateCalculationTypeList';
import { InterestRateTypeComponent } from './Components/InterestRateTypeEdit';

@observer
export default class InvestmentSetupView extends Views.ViewBase<InvestmentSetupVM> {

    constructor(props: unknown) {
        super("Investment Setup", InvestmentSetupVM, props);
    }

    public render() {
        const viewModel = this.viewModel;

        return (
            <div className="pt-3">

                <Neo.TabContainer>
                    <Neo.Tab header="Investment Setup">
                        <p>
                            Please select a tab.
                        </p>
                    </Neo.Tab>
                    <Neo.Tab header="Date Cycles" onInitialise={viewModel.dateCyclesVM.fetchDateCycles}>

                        <DateCycleListComponent viewModel={viewModel.dateCyclesVM} />

                    </Neo.Tab>
                    <Neo.Tab header="Interest Rates" onInitialise={viewModel.interestRateTypesVM.fetchInterestRateTypes}>

                        <InterestRateTypeComponent viewModel={viewModel.interestRateTypesVM} />

                    </Neo.Tab>
                    <Neo.Tab header="Custom Calculation Types" onInitialise={viewModel.interestRateCalculationTypesVM.fetchInterestRateCalculationTypes}>

                        <InterestRateCalculationTypeListComponent viewModel={viewModel.interestRateCalculationTypesVM} />

                    </Neo.Tab>
                </Neo.TabContainer>
            </div>
        );
    }

    public onLeave():  string | undefined {
        if (this.viewModel.interestRateTypesVM?.isDirty || this.viewModel.interestRateCalculationTypesVM?.isDirty || this.viewModel.dateCyclesVM?.isDirty) {
            return "Are you sure you want to leave this page without saving?";
        }
        return undefined;
    }
}